<ng-container *ngIf="(account$ | async) as account">

  <p-card class="card-info w-full my-3">
    <p class="text-center"><strong>Note:</strong> For optimal performance, please add or edit localities within an <em>empty</em> arrangement. Making these changes in an active arrangement may cause issues.</p>
  </p-card>

  <p-table 
    #localitiesTable 
    [value]="account.data.locality" 
    [globalFilterFields]="['name']"
    styleClass="mt-5 p-datatable-striped" 
    dataKey="_meta.id" 
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="localitiesTable.filterGlobal($any($event).target.value, 'contains')" placeholder="Search keyword" />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-locality>
      <tr [pSelectableRow]="locality">
        <td class="locality-text">{{ locality.name }}</td>
        <td class="locality-actions">
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onEditLocality($event, locality, account.data.localityGroup)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="!locality.disabled" pButton pRipple type="button" icon="pi pi-trash" (click)="onDeleteLocality($event, locality)" class="p-button-rounded p-button-danger p-button-text"></button>
          <button *ngIf="locality.disabled" pButton pRipple type="button" icon="pi pi-refresh" (click)="onRestoreLocality($event, locality)" class="p-button-rounded p-button-success p-button-text"></button>
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>